module.exports = __webpack_public_path__ + "static/img/plice1.aa1ba17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plice1.png
// module id = VK8H
// module chunks = 1